
(function () {
  'use strict';
  if (window.__vsInit) return;
  window.__vsInit = true;

  function init(root) {
    if (root.dataset.vsReady === 'true') return;
    root.dataset.vsReady = 'true';

    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-vs-row]'));
    if (!rows.length) return;
    var nameEl = root.querySelector('[data-vs-name]');
    var descEl = root.querySelector('[data-vs-desc]');
    var indexEl = root.querySelector('[data-vs-index]');

    function titleCase(s) {
      return s.length ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s;
    }
    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function refade(el) {
      if (!el) return;
      el.classList.remove('vs-fade');
      void el.offsetWidth;
      el.classList.add('vs-fade');
    }

    function activate(row) {
      if (row.classList.contains('is-active')) return;
      rows.forEach(function (r) { r.classList.toggle('is-active', r === row); });
      if (nameEl) {
        nameEl.textContent = titleCase(row.getAttribute('data-title') || '');
        refade(nameEl);
      }
      if (descEl) {
        descEl.textContent = row.getAttribute('data-desc') || '';
        refade(descEl);
      }
      if (indexEl) {
        indexEl.textContent = pad(rows.indexOf(row) + 1);
      }
    }

    rows.forEach(function (row) {
      row.addEventListener('mouseenter', function () { activate(row); });
      row.addEventListener('focus', function () { activate(row); });
      row.addEventListener('click', function () { activate(row); });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-values-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
